import { UserPayload } from "Types/User";
import { get, put, post, remove, patch } from "../../ApiService";
import { ApiUrl, FiltersType, SsoApiUrl } from "../../ApiUrl";

interface UserFiltersType extends FiltersType {
  organizations?: string; // refs
  projects?: string; // refs
  roles?: string; // platform_roles codes
  statuses?: string; // user_statuses ids
  user_list_type?: string;
  order_by?: string;
  is_admin?: boolean;
  organization_roles?: string; // admin, user, none
}

export const getUsers = async (filters?: UserFiltersType) => {
  try {
    const res = await get(`${SsoApiUrl.userManagement.users}`, {
      page: filters?.page,
      pageSize: filters?.pageSize,
      search: filters?.search,
      organizations: filters?.organizations,
      projects: filters?.projects,
      platform_roles: filters?.roles,
      user_statuses: filters?.statuses,
      user_list_type: filters?.user_list_type,
      ...(filters?.order_by && { order_by: filters.order_by }),
      ...(filters?.is_admin !== undefined && { is_admin: filters.is_admin }),
      ...(filters?.organization_roles && { organization_roles: filters.organization_roles }),
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUser = async (ref: string) => {
  try {
    const res = await get(`${SsoApiUrl.userManagement.user(ref)}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const searchUsersByEmail = async (email: string) => {
  try {
    const res = await get(`${SsoApiUrl.userManagement.users}?search=${email}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUserByEmail = async (email: string) => {
  try {
    const res = await get(`${ApiUrl.profileModule.userMinimal}?email=${email}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUserProjects = async (ref: string, filters?: FiltersType & { filter_associated_projects?: boolean; order_by?: string }) => {
  try {
    const res = await get(
      `${SsoApiUrl.userManagement.userProjects(ref)}`,
      {
        ...filters,
        filter_associated_projects: filters?.filter_associated_projects
      }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateUser = async (ref: string, data: UserPayload | FormData) => {
  try {
    const res = await put(`${SsoApiUrl.userManagement.user(ref)}`, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createUserInvite = async (
  projectRef: string,
  data: {
    email: string;
    role: number;
    organization?: number;
    profile?: {
      first_name: string;
      last_name: string;
      phone_number: string;
      address1: string;
      city: string;
    };
  }
) => {
  try {
    const res = await post(
      `${SsoApiUrl.userManagement.usersInvite}?project=${projectRef}`,
      data
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
